// 1. Imports React
// (Aucun import React nécessaire ici)

// 2. Imports externes
import { Key, Lock } from "lucide-react";

// 4. Imports types
import type { Company } from "@/types/company.type";

// 5. Props
interface CompanyIdentifiersProps {
  company: Company;
}

// 6. Composant
export const CompanyIdentifiers = ({ company }: CompanyIdentifiersProps) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      {/* Login Pointeuse */}
      <div className="space-y-2">
        <label className="text-sm font-medium text-muted-foreground flex items-center gap-2">
          <Key className="h-4 w-4" />
          Login Pointeuse
        </label>
        <div className="p-3  border-b-2 ">
          <p className="text-sm font-mono font-medium">
            {company?.pointeuseLogin || "-"}
          </p>
        </div>
      </div>

      {/* Mot de passe Pointeuse */}
      <div className="space-y-2">
        <label className="text-sm font-medium text-muted-foreground flex items-center gap-2">
          <Lock className="h-4 w-4" />
          Mot de passe Pointeuse
        </label>
        <div className="p-3  border-b-2 ">
          <p className="text-sm font-medium">
            {company?.pointeusePasswordPlain || "Non configuré"}
          </p>
        </div>
      </div>
    </div>
  );
};
